import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import LoginAsUser from "../../../components/loginasuser/LoginAsUser";
import { commonText, roleMange, userManage } from "../../../locales/en";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";
import ErrorBoundary from "../../../components/error-boundary";
const RoleManagementTable = lazy(
  () =>
    import(
      "../../../components/table/all-tables/accessmanagementtable/RoleManagementTable"
    )
);

const Role = () => {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle
        mainTitle={userManage.mainTitle}
        content={roleMange.content}
      />
      <AccessPageAction
        subheading={roleMange.subheading}
        alluser="/admin/access/role"
        allUserTitle={roleMange.subheading}
        createuser="/admin/access/role/create"
        createUserTitle={roleMange.createRole}
      />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-3 mb-3 mx-0">
          <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
            <RoleManagementTable />
          </Suspense>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default Role;
